<template>
  <a
    class="bg-white shadow-2 rounded-12 overflow-hidden flex flex-col transition-opacity duration-300 ease-in-out md:hover:opacity-80"
    :href="article.link"
    :class="{ large: isLarge }"
  >
    <SanityBackground
      v-if="article.image"
      :image="article.image"
      class="image bg-gray-100 no-copyright"
      no-copyright
    />
    <div v-else class="image relative bg-brand-50">
      <svg role="presentation" focusable="false" tabindex="-1" class="absolute inset-0 w-full h-full"   alt="" svg-inline  fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1066">
  <path stroke="#fff" stroke-width="30" d="M508 308h584v450H508z"/>
  <circle cx="872.5" cy="426.5" r="46.5" fill="#fff"/>
  <path d="M585 586.5 706.2 436 821 586.5l95.2-84.5 98.8 84.5V716H585V586.5Z" fill="#fff"/>
</svg>
    </div>
    <div class="no-underline flex flex-1 flex-col p-4 lg:p-5">
      <div
        class="flex-1 text-18 sm:text-16 mb-3 font-bold text-gray-800 leading-5"
        :class="{ 'text-20': isLarge }"
      >
        {{ article.title }}
      </div>
      <div class="text-13 font-semibold text-gray-400 tracking-wide">
        <NuxtTime
          v-if="article.lastUpdated"
          :datetime="article.lastUpdated"
          :locale="$lang"
          date-style="long"
        /><template v-if="article.authorName && article.lastUpdated"> - </template
        ><template v-if="article.authorName">{{ $t('by') }} {{ article.authorName }}</template>
      </div>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { GQLRelatedContentSlice } from './generated/related-content'

defineProps<{
  article: GQLRelatedContentSlice['articleLinks'][number]
  isLarge: boolean
}>()
</script>

<style scoped>
.image {
  padding-top: 49%;
}

@screen lg {
  .image {
    padding-top: 56%;
  }

  .large .image {
    padding-top: 49%;
  }
}
</style>
